import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion";
import { SectionHeading } from "@/components/shared";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { REFUND_POLICY, REFUND_OSSD_TERMS } from "@/data/content";

export default function RefundPolicy() {
  return (
    <>
      <PageHero
        eyebrow="Refund Policy"
        lines={[<>Fair, written down,</>, <span className="font-serif italic font-medium text-brand">no fine print</span>]}
        desc="Tuition is paid in full at the time of enrollment — and we do not lock families into fees for courses that are not the right fit. The essentials are below; the full policy travels with every registration email."
        testid="refund-policy-hero"
      />
      <section className="container-x py-20 sm:py-28" data-testid="refund-policy-page">
        <div className="mx-auto max-w-3xl">
          <SectionHeading
            eyebrow="Refund Policy"
            title={<>Withdrawal windows, <span className="font-serif italic font-medium text-brand">in plain words</span></>}
          />
          <Reveal className="mt-10">
            <Accordion type="single" collapsible className="card-line bg-white px-6" data-testid="refund-policy-accordion">
              {REFUND_POLICY.map((r, i) => (
                <AccordionItem key={i} value={`refund-${i}`}>
                  <AccordionTrigger className="text-left font-display text-base font-semibold text-ink" data-testid={`refund-policy-page-item-${i}`}>
                    {r.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm leading-relaxed text-slate-600">{r.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>

          <Reveal className="mt-10">
            <div className="card-line bg-white p-8 sm:p-10" data-testid="refund-ossd-terms">
              <h3 className="font-display text-lg font-extrabold text-ink">OSSD registration &amp; cancellation</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{REFUND_OSSD_TERMS.intro}</p>
              <ul className="mt-4 space-y-2.5">
                {REFUND_OSSD_TERMS.conditions.map((c) => (
                  <li key={c} className="flex items-start gap-3 text-sm leading-relaxed text-slate-600" data-testid="refund-ossd-condition">
                    <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-brand" />
                    {c}
                  </li>
                ))}
              </ul>
              <p className="mt-6 text-sm font-semibold leading-relaxed text-ink">{REFUND_OSSD_TERMS.ossdIntro}</p>
              <ul className="mt-3 space-y-2.5">
                {REFUND_OSSD_TERMS.ossdConditions.map((c) => (
                  <li key={c} className="flex items-start gap-3 text-sm leading-relaxed text-slate-600" data-testid="refund-ossd-requirement">
                    <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-aqua" />
                    {c}
                  </li>
                ))}
              </ul>
              <div className="mt-6 space-y-3">
                {REFUND_OSSD_TERMS.notes.map((n) => (
                  <p key={n} className="rounded-xl border-l-4 border-brand bg-sand/80 p-5 text-sm font-medium leading-relaxed text-ink sm:text-base" data-testid="refund-ossd-note">
                    {n}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>

          <Reveal className="mt-6">
            <p className="rounded-xl border-l-4 border-aqua bg-brandlight/80 p-5 text-sm font-medium leading-relaxed text-ink sm:text-base" data-testid="refund-bundled-rule">
              {REFUND_OSSD_TERMS.bundledRule}
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
